import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';

const ConditionalHeader = () => {
  const location = useLocation();

  // Define routes where the Header should not appear
  const noHeaderRoutes = ['/login'];

  // Check if the current route is in the list of no-header routes
  const shouldShowHeader = !noHeaderRoutes.includes(location.pathname);

  return shouldShowHeader ? <Header /> : null;
};

export default ConditionalHeader;
